import React from "react";
import "./styles.scss";

const MeatBallsLoader = ({loadingText, style}) => {
  return (
    <>
      <div className="bouncing-loader" style={{marginTop: `${style?.marginTop}px`}}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span className="loading-text">{`${loadingText}`}</span>
    </>
  );
};

export default MeatBallsLoader;
